"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPhotoUpload = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var myPage_1 = require("../../model/myPage");
var service_1 = require("../../../library/base/service");
var UserPhotoUpload = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(UserPhotoUpload, _super);
    function UserPhotoUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '小程序用户头像修改';
        _this.code = '201058';
        _this.desc = '小程序用户头像修改';
        _this.requestParams = new myPage_1.UserPhotoUploadRequest();
        _this.method = fetch_1.Methods.POSTFILE;
        return _this;
    }
    return UserPhotoUpload;
}(service_1.BaseService));
exports.UserPhotoUpload = UserPhotoUpload;
//# sourceMappingURL=userPhotoUpload.js.map